import { render } from "./Opportunities.vue?vue&type=template&id=1cecb232&scoped=true"
import script from "./Opportunities.vue?vue&type=script&lang=js"
export * from "./Opportunities.vue?vue&type=script&lang=js"

import "./Opportunities.vue?vue&type=style&index=0&id=1cecb232&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cecb232"]])

export default __exports__